/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Connect_Point_1Inputs */

const en_landing_step_connect_point_1 = /** @type {(inputs: Landing_Step_Connect_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client agents query your research directly`)
};

/**
* | output |
* | --- |
* | "Client agents query your research directly" |
*
* @param {Landing_Step_Connect_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_connect_point_1 = /** @type {((inputs?: Landing_Step_Connect_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Connect_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_connect_point_1(inputs)
});